/** Testi comuni: portale, menu, barra, login, azioni, errori, home del portale. */
import type { Forma } from "../forma";

export const it = {
  portale: {
    nome: "Qualità",
    titolo: "Portale Qualità",
    dominio: "qa.brandartlab.com",
  },
  menu: {
    home: "Home",
    gruppoRedflag: "Red Flag",
    cruscotto: "Cruscotto",
    segnalazioni: "Segnalazioni",
    azioni: "Le mie azioni",
    report: "Report settimanale",
    gruppoClaim: "Claim fornitori",
    claim: "Claim",
    fornitori: "Fornitori",
    gruppoInArrivo: "In arrivo",
    audit: "Audit e NC fornitori",
    gruppoProposte: "Proposte",
    daApprovare: "Da approvare",
    mieProposte: "Le mie proposte",
    gruppoAdmin: "Amministrazione",
    accessi: "Accessi e ruoli",
    liste: "Liste e criteri",
    registro: "Registro operazioni",
    sfCasi: "Casi Salesforce (prova)",
    apri: "Menu",
  },
  barra: {
    cerca: "Cerca cliente, fornitore, codice RF/NC/claim…",
    nessunRisultato: "Nessun risultato",
    esci: "Esci",
    lingua: "Lingua",
  },
  ricerca: {
    segnalazione: "Segnalazione",
    nc: "NC",
    claim: "Claim",
    fornitore: "Fornitore",
  },
  azioni: {
    salva: "Salva",
    annulla: "Annulla",
    chiudi: "Chiudi",
    conferma: "Conferma",
    modifica: "Modifica",
    aggiungi: "Aggiungi",
    esportaXlsx: "Esporta xlsx",
    indietro: "Indietro",
    ricarica: "Riprova",
    si: "Sì",
    no: "No",
  },
  comune: {
    trattino: "—",
    daAssegnare: "da assegnare",
    daCompilare: "da compilare",
    daIndividuare: "da individuare",
    nessuno: "Nessuno",
    sistema: "sistema",
    salvato: "Salvato",
    tutti: "Tutti",
    caricamento: "Caricamento…",
    sola_lettura: "sola lettura",
    vendorhub: "VendorHub",
    proposto: "proposto",
    inAttesa: "in attesa",
    inArrivo: "in arrivo",
    attiva: "attiva",
    nonIndicato: "non indicato",
    modificheNonSalvate: "Modifiche non salvate",
    altri: "Mostra altri {{n}}",
  },
  errore: {
    generico: "Errore",
    datiNonValidi: "Dati non validi",
    nonAncora: "Funzione non ancora disponibile su questo ambiente",
    caricamento: "Non è stato possibile caricare i dati",
    nonTrovata: "Pagina inesistente",
    nonConsentito: "Questa pagina non è disponibile per il tuo ruolo",
  },
  login: {
    sottotitolo: "Accedi con l'account Brandart",
    microsoft: "Accedi con Microsoft",
    senzaAccesso: "Se non hai accesso, chiedilo: la richiesta arriva all'admin del portale.",
    chiedi: "Chiedi l'accesso",
    motivo: "Perché ti serve (facoltativo)",
    inviata: "Richiesta inviata all'admin del portale",
    sviluppo: "Login di sviluppo",
    entra: "Entra",
  },
  home: {
    sottotitolo: "I processi di qualità di Brandart: un portale, una sezione per sottoprocesso.",
    kpiRfAperti: "Red flag aperti",
    kpiCritici: "{{n}} critici",
    kpiNcSenzaOwner: "NC senza owner",
    kpiSuNc: "su {{n}} NC",
    kpiValore: "Valore a rischio",
    kpiValoreNota: "stima, righe valorizzate",
    kpiClaim: "Claim aperti",
    kpiDaFare: "Da fare per te",
    kpiDaFareNota: "azioni in attesa",
    sezioni: "Sezioni",
    daFare: "Da fare per te",
    niente: "Niente in attesa",
    novita: "Novità della settimana",
    nessunaNovita: "Nessuna novità questa settimana",
  },
};

export const en: Forma<typeof it> = {
  portale: {
    nome: "Quality",
    titolo: "Quality Portal",
    dominio: "qa.brandartlab.com",
  },
  menu: {
    home: "Home",
    gruppoRedflag: "Red Flags",
    cruscotto: "Dashboard",
    segnalazioni: "Reports",
    azioni: "My actions",
    report: "Weekly report",
    gruppoClaim: "Supplier claims",
    claim: "Claims",
    fornitori: "Suppliers",
    gruppoInArrivo: "Coming soon",
    audit: "Supplier audits and NCs",
    gruppoProposte: "Proposals",
    daApprovare: "To approve",
    mieProposte: "My proposals",
    gruppoAdmin: "Administration",
    accessi: "Access and roles",
    liste: "Lists and criteria",
    registro: "Activity log",
    sfCasi: "Salesforce cases (trial)",
    apri: "Menu",
  },
  barra: {
    cerca: "Search customer, supplier, RF/NC/claim code…",
    nessunRisultato: "No results",
    esci: "Sign out",
    lingua: "Language",
  },
  ricerca: {
    segnalazione: "Report",
    nc: "NC",
    claim: "Claim",
    fornitore: "Supplier",
  },
  azioni: {
    salva: "Save",
    annulla: "Cancel",
    chiudi: "Close",
    conferma: "Confirm",
    modifica: "Edit",
    aggiungi: "Add",
    esportaXlsx: "Export xlsx",
    indietro: "Back",
    ricarica: "Retry",
    si: "Yes",
    no: "No",
  },
  comune: {
    trattino: "—",
    daAssegnare: "to be assigned",
    daCompilare: "to be filled in",
    daIndividuare: "to be identified",
    nessuno: "None",
    sistema: "system",
    salvato: "Saved",
    tutti: "All",
    caricamento: "Loading…",
    sola_lettura: "read only",
    vendorhub: "VendorHub",
    proposto: "proposed",
    inAttesa: "pending",
    inArrivo: "coming soon",
    attiva: "active",
    nonIndicato: "not stated",
    modificheNonSalvate: "Unsaved changes",
    altri: "Show {{n}} more",
  },
  errore: {
    generico: "Error",
    datiNonValidi: "Invalid data",
    nonAncora: "Feature not yet available in this environment",
    caricamento: "The data could not be loaded",
    nonTrovata: "Page not found",
    nonConsentito: "This page is not available for your role",
  },
  login: {
    sottotitolo: "Sign in with your Brandart account",
    microsoft: "Sign in with Microsoft",
    senzaAccesso: "If you have no access, request it: the request goes to the portal admin.",
    chiedi: "Request access",
    motivo: "Why you need it (optional)",
    inviata: "Request sent to the portal admin",
    sviluppo: "Development login",
    entra: "Sign in",
  },
  home: {
    sottotitolo: "Brandart quality processes: one portal, one section per sub-process.",
    kpiRfAperti: "Open red flags",
    kpiCritici: "{{n}} critical",
    kpiNcSenzaOwner: "NCs without owner",
    kpiSuNc: "out of {{n}} NCs",
    kpiValore: "Value at risk",
    kpiValoreNota: "estimate, rows with a value",
    kpiClaim: "Open claims",
    kpiDaFare: "Your to-do",
    kpiDaFareNota: "pending actions",
    sezioni: "Sections",
    daFare: "Your to-do",
    niente: "Nothing pending",
    novita: "This week's news",
    nessunaNovita: "No news this week",
  },
};
